import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import { MapWithIndex } from '../../../lib/helpers';
import { ImgPreload } from '../../../lib/AirUI';

const thumbnailCascadeStyle = counter => {
  const baseCss = {
    height: '80px',
    width: '94px',
  };
  if (counter == 0) {
    baseCss.borderRadius = '8px 0px 0px 0px';
  }
  if (counter == 2) {
    baseCss.borderRadius = '0px 8px 0px 0px';
  }
  return baseCss;
};

const AudienceCard = styled.div`
  cursor: pointer;
  position: relative;
  width: 282px;
  height: 134px;
  background: transparent;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04);
  border-radius: 8px;

  @media (max-width: 767px) {
    position: relative;
    width: 16.6rem;
    height: 105px;
    margin: 45px auto;
  }
`;

const CardTitleStyle = styled.div`
  width: 100%;
  background-color: white;
  padding: 8px 16px;
  color: ${themeGet('colors.black.100')};
  height: 54px;
  line-height: 18px;
  letter-spacing: 0.2px;
  border-radius: 0px 0px 8px 8px;
`;

const ImagesSection = styled.div`
  display: flex;
  text-align: center;
  width: 100%;
  height: 80px;
  border-radius: 8px 8px 0px 0px;
  background-color: ${themeGet('colors.black.100')};
  img {
    opacity: 0.4;
  }
`;

const renderThumbnails = (thumbnails, missingThumbPath) =>
  MapWithIndex([...thumbnails].reverse(), (thumbnail, i) => (
    <ImgPreload
      src={thumbnail}
      loadingSrc={missingThumbPath}
      loadingStyle={thumbnailCascadeStyle(i)}
      style={thumbnailCascadeStyle(i)}
      key={i}
    />
  ));

const AudienceComponent = props => (
  <AudienceCard
    onClick={() => props.audienceRedirect(props)}
    className="campaign-card"
  >
    <ImagesSection>
      {renderThumbnails(props.thumbnails, props.missingThumbPath)}
    </ImagesSection>
    <CardTitleStyle className="card-title">{props.name}</CardTitleStyle>
  </AudienceCard>
);

export default AudienceComponent;
